<template>
  <div>
    <doctor-header></doctor-header>

    <div class="header-separator"></div>

    <div style="background-color: rgba(255, 255, 255, .9); margin-top: 200px;">
      <v-form ref="form" v-model="valid" lazy-validation class="pt-3" @keyup.native.enter="submit">
        <v-container class="site-padding">
          <v-layout row wrap class="register-form mx-1">
            <v-flex xs12 class="text-xs-left my-text">
              <h1 class="doctors-container--header">obejrzyj transmisję</h1>
              <div class="sparator-container pt-4">
                <div class="sparator-rectangle"></div>
              </div>
              <div>
                <span>Podaj adres email:</span>
                <ul>
                  <li>wykorzystywany do logowania w serwisie PTO - dotyczy członków z opłaconą bieżącą składką</li>
                  <li>zgłoszony przez gabinet specjalistyczny, biorący udział w akcji</li>
                </ul>
              </div>

              <div class="mt-3">
                <span>W przypadku problemów związanych z logowaniem, skontaktuj sie administratorem</span>
                <ul>
                  <li>napisz do nas na skrzynkę: tydzienjaskry@pto.com.pl</li>
                  <li>lub zadzwoń na numer: 798 344 577</li>
                </ul>
              </div>
            </v-flex>
          </v-layout>
        </v-container>

        <v-container class="site-padding">
          <v-layout row wrap class="register-form mx-1">
            <v-flex xs12 md6 class="text-xs-left px-md-3 pl-md-0 pl-2 pr-md-0 pr-4">
              <v-text-field
                label="E-mail"
                solo
                v-model="participant.email"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>

        <v-container>
          <v-layout row class="mt-3" @click="submit">
            <v-flex class="xs12 sm6">
              <my-button
                text="Obejrzyj<br>transmisję</span>"
                customClass="doctor rect-x1"
              />
            </v-flex>

            <v-flex class="mt-3  align-content-center" v-if="message">
              <b>{{ message }}</b>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </div>

    <div class="header-separator" style="height: 50px;"></div>
  </div>
</template>

<script>
  import DoctorHeader from '@/components/partials/DoctorHeader';
  import MyButton from '@/components/partials/Button';
  import moment from 'moment';

  export default {
    data() {
      return {
        valid: false,
        participant: {
          email: '',
        },
        message: '',
      };
    },
    components: {
      DoctorHeader,
      MyButton,
      moment,
    },
    methods: {
      submit() {
        this.axios({
          method: 'GET',
          url: `${process.env.APP_URL}/api/transmission-url/${this.participant.email}`,
        })
          .then((result) => {
            if (result && result.data.token) {
              window.location = `${window.location}/${result.data.token}`
            }
          }, (err) => {
            this.message = err.response.data.message
          });
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .term-container--position {
    align-items: baseline !important;
  }

  .message {
    background: #ab2929;
    color: white;
    font-weight: bold;
    width: 100%;
    text-align: center;

    /* height: 50px; */
    padding: 60px 0;
    /* margin-left: 30px; */
    margin: 60px 0;
    font-size: 1.8rem;
  }
  .navigation-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-end;
    align-content: end;
    align-items: end;
  }
  .navigation-container--position {
    order: 0;
    flex: 0 1 auto;
    align-self: center;
    border-bottom: 5px solid #fff;
  }
  .banner { background-color: transparent; }

  .wrapper {
    width: 100%;
    margin: 0 auto;
  }

  .banner .text-container {
    font-family: 'Fira Sans', sans-serif;
    text-align: left;
    color: #aaa;
    display: flex;
    vertical-align: middle;
    flex-direction: row;
    align-items: center;
  }
  .banner img {
    float: left;
  }

  .time-container {
    display: inline-flex;
    width: 100%;
  }
  .time-container--separator {
    width: 145px;
    padding-right: 5px;
  }
  .doctors-container--inputs {
    width: 100%;
    padding: 12px 20px;
    margin: 8px 0;
    box-sizing: border-box;
  }
  .doctors-container--header {
    font-size: 26px;
    font-family: 'Fira Sans', sans-serif;
    font-weight: 900;
    color: #a41611;
    text-transform: uppercase;
  }
  .doctors-container--links {
    color: #a41611;
    font-family: 'Fira Sans', sans-serif;
  }
  .doctors-container--sections {
    color: #275271;
    font-family: 'Fira Sans', sans-serif;
    font-weight: 900;
    text-transform: uppercase;
  }
  .doctors-container--sections-brown {
    color: #a41611;
  }
  .doctors-container--sections-slim {
    color: #000;
    font-weight: 500;
    text-transform: lowercase;
  }
  .doctors-container--icons {
    background: #275271;
    vertical-align: middle;
    border-radius: 50%;
    width: 120px;
    height: 120px;
    line-height: 120px;
    border: none;
    padding: 20px;
  }
  .doctors-container--icons-brown {
    background: #a82824;
  }
  .sparator-container {
    border-bottom: 1px solid black;
    margin-bottom: 10px;
  }
  .sparator-rectangle {
    width: 115px;
    height: 8px;
    background-color: #275271;
  }
  .no-padding {
    padding: 0px !important;
    margin-top: 7px;
  }
  .register-bg {
    position: relative;
  }
  .register-bg::before {
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    content: '';
    position: fixed;
    opacity: 0.1;
    background-image: url('./../assets/images/register-bg.png');
    background-repeat: repeat;
    background-position: center center;
  }
  .doctor-header {
    background: #a82824;
    opacity: 0.9;
  }
  .free-main-header {
    background: #d9e7ee;
    opacity: 0.9;
  }
  .free-main-header--text {
    font-family: 'Fira Sans', sans-serif;
    font-size: 12px;
  }
  .main-header--wgw {
    width: 125px;
  }
  .main-header--pto {
    width: 90px;
  }
  @media only screen and (min-width: 1024px) and (max-width: 2560px) {
    .main-header--wgw {
      width: 240px;
    }
    .main-header--pto {
      width: 200px;
    }
  }
  .main-header--free {
    width: 280px;
  }
  .button-container-blue {
    background: #275271;
    opacity: 0.9;
    cursor: pointer;
  }
  .button-container-red {
    background: #a82824;
    opacity: 0.9;
    position: relative;
    cursor: pointer;
  }
  .button-container--register {
    font-family: 'Fira Sans', sans-serif;
    font-size: 40px;
    line-height: 40px;
    font-weight: 900;
    color: #fff;
    text-decoration: none;
    text-transform: uppercase;
  }
  .doctor-header--text {
    font-family: 'Fira Sans', sans-serif;
    font-size: 50px;
    line-height: 50px;
    font-weight: 900;
    width: 50%;
    color: #fff;
    padding-left: 10px;
    padding-top: 20px;
    text-transform: uppercase;
  }
  .button-container--text {
    font-family: 'Fira Sans', sans-serif;
    font-size: 26px;
    font-weight: 900;
    color: #fff;
    text-decoration: none;
    text-transform: uppercase;
  }
  .button-container--arrow {
    margin-right: 20px
  }
  .free-main-header--margin {
    margin-top: 100px;
  }
  .button-container--margin {
    margin-bottom: 30px;
  }
  .button-container--padding {
    padding-top: 50px!important;
    padding-bottom: 50px!important;
  }
  .button-container--position {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: flex-end;
  }
  .videoWrapper {
    position: relative;
    width: 95%;
    left: 5%;
    top: 3%;
    padding-bottom: 56.25%; /* 16:9 */
    height: 0;
  }
  .videoWrapper iframe {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 10px;
  }
  .button-container--separator {
    position: absolute;
    top: 0;
    width: 115px;
    height: 10px;
    background: #ffffff;
  }
  .doctors-container--download {
    text-decoration: none;
    display: flex;
    vertical-align: middle;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .doctors-container--download-text {
    display: flex;
    vertical-align: middle;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: flex-start;
    padding-left: 15px;
  }
  @media only screen and (max-width: 600px) {
    .button-container--arrow {
      width: 20px;
      margin-right: 5px
    }
    .button-container--text {
      font-size: 26px;
    }
  }
  .register-form--noShadow {
    -webkit-box-shadow: none!important;
    box-shadow: none!important;
  }
  .register-container--download {
    text-decoration: none;
    display: flex;
    vertical-align: middle;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .register-container--download-text {
    display: flex;
    vertical-align: middle;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: flex-start;
    padding-left: 15px;
  }
  .register-container--sections {
    color: #275271;
    font-family: 'Fira Sans', sans-serif;
    font-weight: 900;
    text-transform: uppercase;
  }
</style>



// WEBPACK FOOTER //
// src/components/Transmission.vue